import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';

@Component({
    selector: 'app-bad-url',
    templateUrl: './bad-url.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BadUrlComponent {
  constructor(@Inject(EnvironmentToken) private environment: Environment) {
    window.location.href = this.environment.matHost;
  }
}
